import { render, staticRenderFns } from "./OrderCarat.vue?vue&type=template&id=a28f5384&"
import script from "./OrderCarat.vue?vue&type=script&lang=ts&"
export * from "./OrderCarat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports